/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

export const SidebarID = {
	//Storybook Sample
	Zero: "Zero",
	One: "One",
	Two: "Two",
	Three: "Three",
	//Space
	Space: "Space",
	CreateSpace: "CreateSpace",
	InviteContactMember: "InviteContactMember",
	CreateWorkGroup: "CreateWorkGroup",
	FindGroupSpace: "FindGroupSpace",
	GroupPanel: "GroupPanel",
	SpacePanel: "SpacePanel",
	MyRoomPanel: "MyRoomPanel",
	AddUserPanel: "AddUserPanel",
	GroupSetting: "GroupSetting",
	SpaceSetting: "SpaceSetting",
	MyRoomSetting: "MyRoomSetting",
	InviteSpaceMember: "InviteSpaceMember",
	ManageSpaceMember: "ManageSpaceMember",
	UserProfile: "UserProfile",
	ViewEntireSpaces: "ViewEntireSpaces",
	// Meeting
	Meeting: "Meeting",
	MeetingReservation: "MeetingReservation",
	PreviousMeeting: "PreviousMeeting",
	WaitingMeeting: "WaitingMeeting",
	DetailMeeting: "DetailMeeting",
	CreateConference: "CreateConference",
	MeetingInfo: "MeetingInfo",
	CreateMeeting: "CreateMeeting",
	ConfirmMeetingReservation: "ConfirmMeetingReservation",
	MeetingSetting: "MeetingSetting",
	MeetingEdit: "MeetingEdit",
	ReservationMeetingEdit: "ReservationMeetingEdit",
	PrivateMeetingDetail: "PrivateMeetingDetail",
	//People
	People: "People",
	PeopleDetail: "PeopleDetail",
	//Chat
	Chat: "Chat",
	FullSizeChat: "FullSizeChat",
	//Phone
	Phone: "Phone",
	ChatSearch: "ChatSearch",
	UnityPanel: "UnityPanel",
	PhoneDetail: "PhoneDetail",
	//Activity
	Activity: "Activity",
	ActivityFullSizeThread: "ActivityFullSizeThread",
	ActivityFullSizeChat: "ActivityFullSizeChat"
} as const;
export type SidebarID = (typeof SidebarID)[keyof typeof SidebarID];
